module.exports = __webpack_public_path__ + "img/logo-gapp.6cf2cc7c.png";